import React from 'react';
import './header.css'
import quochuy from '../../assets/img/Quoc_Huy_Viet_Nam_Chuan.png'

function Header () {
    
        return (
            <div>
                  <header className="header">
      {/* <!-- LEFT --> */}
      <div className="header-left">
        <div className="logo">
          <img src={quochuy} className="quochuy" alt="logo"/>
        </div>

        <div className="header-text">
          <div className="top-title">SỞ CÔNG THƯƠNG TỈNH AN GIANG</div>

          <div className="bottom-title">
            HỆ THỐNG DỮ LIỆU NGÀNH CÔNG THƯƠNG
          </div>
        </div>
      </div>

      {/* <!-- RIGHT --> */}
      <div className="header-right">
        {/* <!-- Notification --> */}
        <div className="notify">
          <i className="fa-regular fa-bell"></i>

          <div className="notify-count">5</div>
        </div>

        {/* <!-- Help --> */}
        <div className="help">
          <i className="fa-regular fa-circle-question"></i>
        </div>

        {/* <!-- User --> */}
        <div className="user-box">
          <div className="avatar">
            <i className="fa-solid fa-user"></i>
          </div>

          <div className="user-info">
            <div className="name">admin</div>
            <div className="role">Quản trị hệ thống</div>
          </div>

          <div className="down-icon">
            <i className="fa-solid fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </header>
            </div>
        );

}



export default Header;